<template>
  <div>
    <job-header-simple header_title="签名认证"></job-header-simple>
    <!-- 手写签名区 -->
    <div class="view-choose">
      <div class="view-sign" @click="choosePic1" >
        <img class="icon-chooose" src="./assets/icon_success.png" v-show="checked==='pic1'">
        <p class="view-bg" v-show="!showImg"> <img class="icon-sign" src="./assets/icon_sign.png">手绘签名</p>
        <img class="img-pic" alt="" :src="imgSrc" v-show="showImg">
      </div>
    </div>

    <!-- 字体签名区 -->
    <div class="view-image">
      <div class="view-text" @click="choosePic2" >
        <img class="icon-suc" src="./assets/icon_success.png"  v-show="checked==='pic2'">
        <img class="img-pic2" :src="img2" alt="">
      </div>
      <div class="view-text" @click="choosePic3" >
        <img class="icon-suc" src="./assets/icon_success.png" v-show="checked==='pic3'">
        <img class="img-pic2" :src="img3" alt="">
      </div>
    </div>
    <div class="view-p">
      <p>*只能绘制一个签名，采用后不能再修改</p>
    </div>
      <div class="checkbox">
        <label for="checkXy"><input id="checkXy" class="checkxy" type="checkbox" v-model="xyChecked">勾选即代表同意签署</label>
        <span class="xyCompany" @click="toXyCompany">{{xyCompany}}</span>
        <span class="xyCompany" @click="toDqXy">《工蚁宝平台服务协议》</span>
      </div>
    <div class="bg-button">
      <van-button class="view-bt" type="info" size="large" color="#6c7ef3" plain @click="signClear">清除</van-button>
      <van-button class="view-bt" type="info" size="large" color="#6c7ef3" @click="saveImg">采用</van-button>
    </div>

    <!-- 横屏签名 -->
    <van-popup
    v-model="showPop"
    closeable
    position="right"
    close-icon="close"
    close-icon-position="bottom-right"
    @close="closeSignHor"
    :style="{ height: '100%',background: '#fff'}">
      <div @click="canvasClearHor" class="bt-hor">清除</div> 
      <div @click="canvasSaveHor" class="bt-save">保存</div>
      <sign-canvas ref="SignCanvasHor" :options="options" v-model="value" />
    </van-popup>
  </div>
</template>

<script>
import {
  button,
  Toast,
  Popup,
  Dialog,
  Icon,
  Checkbox
} from "vant";
import jobHeaderSimple from "@/components/header/header.vue";
import api from "@/api/list";
import SignCanvas from "sign-canvas";
import {
  getImage,
  getImage2
} from "@/api/getChinessImage/request";

export default {
  components: {
    [button.name]: button,
    [Toast.name]: Toast,
    [Popup.name]: Popup,
    [Icon.name]: Icon,
    [Checkbox.name]: Checkbox,
    jobHeaderSimple,
    SignCanvas
  },
  data() {
    return {
      ocompanyId:this.$route.query.ocompanyId,
      signButtonFlag:false,
      user:{},
      value: null, //手写生成图片的base64
      imgSrc: null, //图片旋转后的base64
      showPop: false, // 弹窗显示
      showImg: false, // 展示写好的签名
      checked:'pic1',
      xyChecked:false,
      xyCompany:'', // 《江西工悦科技有限公司-服务协议》
      toXy:'',
      img2: '',
      img3: '',
      options:{
        isDpr: false,       //是否使用dpr兼容高分屏 [Boolean] 可选
        lastWriteSpeed: 1,  //书写速度 [Number] 可选
        lastWriteWidth: 1,  //下笔的宽度 [Number] 可选
        lineCap: 'round',   //线条的边缘类型 [butt]平直的边缘 [round]圆形线帽 [square]	正方形线帽
        lineJoin: 'bevel',  //线条交汇时边角的类型  [bevel]创建斜角 [round]创建圆角 [miter]创建尖角。
        canvasWidth: window.screen.availWidth,  //canvas宽高 [Number] 可选
        canvasHeight: window.screen.availHeight, //高度  [Number] 可选
        isShowBorder: false, //是否显示边框 [可选]
        bgColor: '#ffffff', //背景色 [String] 可选
        borderWidth: 1, // 网格线宽度  [Number] 可选
        borderColor: "#ff787f", //网格颜色  [String] 可选
        writeWidth: 10, //基础轨迹宽度  [Number] 可选
        maxWriteWidth: 30, // 写字模式最大线宽  [Number] 可选
        minWriteWidth: 10, // 写字模式最小线宽  [Number] 可选
        writeColor: '#000000', // 轨迹颜色  [String] 可选
        isSign: true, //签名模式 [Boolean] 默认为非签名模式,有线框, 当设置为true的时候没有任何线框
        imgType:'png'   //下载的图片格式  [String] 可选为 jpeg  canvas本是透明背景的
      },
    };
  },
  created() {
    this.initData()
  },
  methods: {
    initData(){
     getImage().then((res) => {
          if (res.status == "200") {
              this.blobToBase64(res.data).then((res)=>{
                this.img2 = res
              });
          }
      });
      getImage2().then((res) => {
        if (res.status == "200") {
            this.blobToBase64(res.data).then((res)=>{
              this.img3 = res
            });
        }
      });
       api.getPdfUrlByOcompanyId({ocompanyId:this.ocompanyId}).then((res) => {
          if (res.data.status == "200") { // 身份认证通过，跳转到视频认证接口
            if (res.data.data.ocompanyName&&res.data.data.pdfUrl) {
              this.xyCompany = `《${res.data.data.ocompanyName}-服务协议》`;
              this.toXy = res.data.data.pdfUrl;
            }
          }
        })

        let imgData = sessionStorage.getItem("imgData");
        if (imgData) {
          this.imgSrc = imgData
          this.showImg = true;
        }
    },
    toXyCompany(){
      if (this.toXy.toUpperCase().endsWith(".PDF")) {
        if (this.imgSrc) {
          sessionStorage.setItem("imgData",this.imgSrc)
        }
        this.$router.push({
          path: "/checkContract",
          query: {
            fileURL:  process.env.VUE_APP_FILE_PATH+this.toXy,
            header_title: this.xyCompany,
          },
        });

      }
    },
    toDqXy(){
      if (this.imgSrc) {
        sessionStorage.setItem("imgData",this.imgSrc)
      }
      this.$router.push({
        path: "/dianqianxieyi",
      });
    },
    blobToBase64(blob) {
       return new Promise((resolve, reject) => {
         const fileReader = new FileReader();
         fileReader.onload = (e) => {
           resolve(e.target.result);
         };
         // readAsDataURL
         fileReader.readAsDataURL(blob);
         fileReader.onerror = () => {
           reject(new Error('文件流异常'));
         };
       });
    },
    choosePic1(){
      if(this.showImg){
        this.checked = 'pic1';
      }else{
        this.checked = 'pic1';
        this.showPop = true;
        if(this.$refs.SignCanvasHor) {
          this.imgSrc = null;
          this.$refs.SignCanvasHor.canvasClear();
        }
      }
    },
    choosePic2(){
      this.checked = 'pic2';
    },
    choosePic3(){
       this.checked = 'pic3';
    },
    // 清除
    signClear() {
      this.showImg = false;
      if(this.$refs.SignCanvasHor) {
        this.imgSrc = null;
        this.$refs.SignCanvasHor.canvasClear();
      }
    },
    closeSignHor() {
      if(this.value) {
        this.rotateBase64Img(this.value,-90);
      }
    },
    // 横屏清除
    canvasClearHor() {
      if(this.$refs.SignCanvasHor){
        this.imgSrc = null;
        this.$refs.SignCanvasHor.canvasClear();
      }
    },
    // 横屏签名保存
    canvasSaveHor() {
      this.showPop = false;
    },
    compressImg(src){
      return new Promise((resolve,reject) =>{
          // 创建一个 Image 对象
        let image = new Image();
        // 绑定 load 事件处理器，加载完成后执行
        let MAX_HEIGHT = 32;
        image.onload = function() {
            // 获取 canvas DOM 对象
            let canvas = document.createElement("canvas");
            
            // 如果高度超标
            if (image.height > MAX_HEIGHT) {
                console.log('执行');
                // 宽度等比例缩放 *=
                image.width *= MAX_HEIGHT / image.height;
                image.height = MAX_HEIGHT;
            }
            // 获取 canvas的 2d 画布对象,
            let ctx = canvas.getContext("2d");
            // canvas清屏，并设置为上面宽高
            ctx.clearRect(0, 0, canvas.width, canvas.height);
            

            // 重置canvas宽高
            canvas.width = image.width;
            canvas.height = image.height;
            
            // 将图像绘制到canvas上
            ctx.drawImage(image, 0, 0, image.width, image.height);
            resolve(canvas.toDataURL("image/png", 0.2))
        };
        image.src = src;
      });
    },
    rotateBase64Img(src, edg) {
      let _self  = this;
      let canvas = document.createElement("canvas");
      let ctx = canvas.getContext("2d");
      let imgW;//图片宽度
      let imgH;//图片高度
      let size;//canvas初始大小
      if (edg % 90 != 0) {
          console.error("旋转角度必须是90的倍数!");
          throw '旋转角度必须是90的倍数!';
      }
      (edg < 0) && (edg = (edg % 360) + 360)
      const quadrant = (edg / 90) % 4; //旋转象限
      const cutCoor = {sx: 0, sy: 0, ex: 0, ey: 0}; //裁剪坐标
      let image = new Image();
      image.crossOrigin = "anonymous"
      image.src = src;
      image.onload = function () {
          imgW = image.width;
          imgH = image.height;
          size = imgW > imgH ? imgW : imgH;
          canvas.width = size * 2;
          canvas.height = size * 2;
          switch (quadrant) {
              case 0:
                  cutCoor.sx = size;
                  cutCoor.sy = size;
                  cutCoor.ex = size + imgW;
                  cutCoor.ey = size + imgH;
                  break;
              case 1:
                  cutCoor.sx = size - imgH;
                  cutCoor.sy = size;
                  cutCoor.ex = size;
                  cutCoor.ey = size + imgW;
                  break;
              case 2:
                  cutCoor.sx = size - imgW;
                  cutCoor.sy = size - imgH;
                  cutCoor.ex = size;
                  cutCoor.ey = size;
                  break;
              case 3:
                  cutCoor.sx = size;
                  cutCoor.sy = size - imgW;
                  cutCoor.ex = size + imgH;
                  cutCoor.ey = size + imgW;
                  break;
          }
          ctx.translate(size, size);
          ctx.rotate(edg * Math.PI / 180);
          ctx.drawImage(image, 0, 0);
          let imgData = ctx.getImageData(cutCoor.sx, cutCoor.sy, cutCoor.ex, cutCoor.ey);
          if (quadrant % 2 == 0) {
              canvas.width = imgW;
              canvas.height = imgH;
          } else {
              canvas.width = imgH;
              canvas.height = imgW;
          }
          for(let i = 0; i < imgData.data.length; i += 4) {
            // 当该像素是透明的,则设置成白色
            if(imgData.data[i + 3] == 0) {
              imgData.data[i] = 255;
              imgData.data[i + 1] = 255;
              imgData.data[i + 2] = 255;
              imgData.data[i + 3] = 255;
            }
          }

          ctx.putImageData(imgData, 0, 0);
          _self.showImg = true;
          _self.imgSrc = canvas.toDataURL("image/png");
      };
    },
    // 保存图片
    saveImg() {
        if (!this.xyChecked) {
          this.$toast({
            message: `请勾选并同意签署${this.xyCompany}《工蚁宝平台服务协议》`,
          });
          return
        }
        this.signButtonFlag=true;
        let img = null;
        switch (this.checked) { 
          case 'pic1':
            if(this.imgSrc){
              this.compressImg(this.imgSrc).then(data => {
                this.registerIndividualBusiness(data);
              });
              return;
            }else{
              Dialog.alert({
                title: "提示",
                message: "请绘制签名",
              })
            }
          break; 
          case 'pic2':
            img = this.img2;
          break; 
          case 'pic3':
            img = this.img3;
          break;
        }
        if(!img) return;
        this.registerIndividualBusiness(img);
    },
    registerIndividualBusiness(signBase64){
        Toast.loading({
          mask: true,
          message: "上传中...",
          forbidClick: true,
          duration: 0
        });
        api.registerIndividualBusiness({ signBase64: signBase64,ocompanyId:this.ocompanyId},{ method: "post" }).then((res) => {
             Toast.clear();
             if (res.data.status == "200") { // 身份认证通过，跳转到视频认证接口
                this.$router.push({
                   path: "/individual_finish"
               });
             }else{ // 注册失败
                 Dialog.alert({
                      title: "提示",
                      message: res.data.message,
                   }).then(() => {});
                 this.signButtonFlag=false;
              }
           })
    }
  },
};
</script>

<style lang="less" scoped>
.view-choose {
  background: #ffffff;
  padding: 20px 20px;
  display: flex;
  justify-content: center;
  .view-sign {
    width: 100%;
    height: 200px;
    text-align: center;
    line-height: 200px;
    position: relative;
    border: 3px solid #F0F2F5;
    .icon-chooose {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 10px;
      right: 10px;
       z-index:999;
    }
    .view-bg{
      color: #6C7EF3;
      text-align: center;
      font-size: 26px;
      .icon-sign{
        height: 34px;
        width: 34px;
        padding-right: 6px;
        margin-bottom: -6px;
      }
    }
    .img-pic {
      width: 100%;
      height: 100%;
    }
  }
}
.view-image {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #ffffff;
  padding: 0 20px 20px;
  .view-text {
    position: relative;
    text-align: center;
    width: 45%;
    height: 100px;
    background: white;
    border: 3px solid #F0F2F5;
    .icon-suc {
      width: 20px;
      height: 20px;
      position: absolute;
      top: 5px;
      right: 5px;
      z-index:999;
    }
    .img-pic2{
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      width: 50%;
      height: 25%;
    }
  }
}
.bg-button {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  padding: 20px 0;
  position: fixed;
  width: 100%;
  bottom: 0;
  .view-bt {
    margin: 10px;
  }
}
.view-p {
  color: #6c7ef3;
  font-size: 14px;
  text-align: center;
  background: #ffffff;
  
  p{
    padding: 20px;
  }

}
.checkbox{
  font-size: 14px;
  text-align: left;
  line-height: 24px;
  text-align: left;
  padding: 20px 20px;
  color: #999;
  margin-bottom: 60px;
  .checkxy{
    position: relative;
    top: 1.4px;
  }
  .xyCompany{
    color: #6c7ef3;
  }
  a{
    color: #6c7ef3;
  }
}
.bt-hor{
  position:absolute;
  text-align: center;
  bottom: 150px;
  height: 36px;
  width: 56px;
  background-color: red;
  color: #fff;
  border-radius: 4px;
	font-size: 16px; 
	line-height: 40px;
	transform:rotate(90deg);
}
.bt-save{
  position:absolute;
  text-align: center;
  bottom: 50px;
  height: 36px;
  width: 56px;
  background-color: #6c7ef3;
  color: #fff;
  border-radius: 4px;
	font-size: 16px; 
	line-height: 40px;
	transform:rotate(90deg);
}
</style>


